<template>
  <div class="nut-chart">
    <head-line>
     {{$ml.get('Interpretation Chart')}}
    </head-line>

    <div class="chart-cnt">
      <HorChart class="bar-chart" :chart-data="chartData" :options="options"/>
    </div>
  </div>
</template>

<script>
import HorChart from './../common/HorChart'

export default {
  data() {
    return {
      options: {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
              callback: (value, index, values) => {
                  return this.$ml.get(this.$levelToInterpretation(value));
              }
            }
          }]
        }
      }
    }
  },
  methods: {
    getColor(item) {
      // #EC5A60 - Excessive
      // #F2B14E - High
      // #A7B975 - Adequate
      // #5EC19B - Low

      const lvl = this.$interpretationToLevel(item.interpretation);

      if(lvl === 4) {
        return '#EC5A60';
      }
      else if(lvl === 3) {
        return '#F2B14E';
      }
      else if(lvl === 2) {
        return '#A7B975';
      }
      else if(lvl === 1) {
        return '#5EC19B';
      }
    },
  },
  components: {
    HorChart,
  },
  computed: {
    section() {
      return this.$root.data.soilTest;
    },
    dataSets() {
      const filtered_data = this.section.data.data
        .filter(n => n.value != null)
      return [
        {
          backgroundColor: filtered_data.map(n => this.getColor(n)),
          data: filtered_data.map(n => this.$interpretationToLevel(n.interpretation)),
        }
      ]
    },
    chartData() {
      return {
        labels: this.section.data.data
          .filter(n => n.value != null)
              .map(n => n.type),
        datasets: this.dataSets,
      }
    }
  },
}
</script>

<style lang="scss" scoped>

::v-deep {
  .bar-chart {
    width: 100%;
    max-width: 500px;
  }
}

.nut-chart {
  .chart-cnt {
    width: 100%;
    padding-top: 50px;

    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

</style>
